import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useAuth } from '../../../hooks/useAuth'
import { buscarDetalle } from '../../servicios/publicacionesService'
import BordeDetalle from '../../ui/BordeDetalle'
import styles from '../Publicaciones.module.css'
import AdministrarPublicacion from './AdministrarPublicacion'

const Detalle = () => {
  const [publicacion, setPublicacion] = useState({})
  const navigate = useNavigate()
  const { idPublicacion } = useParams()
  const { loginDataContext: { idUsuario } = {}, esPerfilAdmin } = useAuth()

  const obtenerPublicacion = async () => {
    if (!idUsuario) return
    try {
      const { data } = await buscarDetalle(idPublicacion)
      const esVendedorDePublicacion = Number(data?.idVendedor) === Number(idUsuario)
      const puedeAdministrar = Boolean(esPerfilAdmin) || esVendedorDePublicacion

      if (data && puedeAdministrar) {
        setPublicacion(data)
      } else {
        navigate('/Publicaciones/Administrar')
      }
    } catch {
      navigate('/Publicaciones/Administrar')
    }
  }

  useEffect(() => {
    obtenerPublicacion()
  }, [idPublicacion, idUsuario])

  const onCerrarClick = () => {
    navigate(-1)
  }

  return (
    <BordeDetalle
      titulo={'Administrar Publicaciones'}
      onCerrarClick={() => onCerrarClick()}
      className={styles.fieldset}
    >
      <AdministrarPublicacion
        publicacion={publicacion}
        setPublicacion={setPublicacion}
        idPublicacion={idPublicacion}
      />
    </BordeDetalle>
  )
}

Detalle.propTypes = {
  entidad: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired
  }).isRequired,
  actualizarPantallaDetalle: PropTypes.func.isRequired,
  onActualizarPantalla: PropTypes.func.isRequired,
  idPublicacion: PropTypes.number.isRequired
}

export default Detalle
